import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const SemanticSearch = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.5 145c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5-51 1.567-51 3.5 22.834 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M108.743 125.641C98.103 134.601 84.36 140 69.356 140c-10.04 0-19.516-2.418-27.875-6.702-.642-.738-.981-1.507-.981-2.298 0-5.523 16.566-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        d="M108.743 125.641C98.103 134.601 84.36 140 69.356 140c-10.04 0-19.516-2.418-27.875-6.702-.642-.738-.981-1.507-.981-2.298 0-5.523 16.566-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill="#D9D9D9"
        fillRule="evenodd"
        d="m63.084 139.683 2.962-.794a3.31 3.31 0 0 0 2.34-4.054l-5.997-22.381a3.3 3.3 0 0 0-1.542-2.01 3.321 3.321 0 0 0-2.512-.33l-22.381 5.997h-.001a3.31 3.31 0 0 0-2.34 4.054l2.726 10.173a60.993 60.993 0 0 0 10.76 5.489l7.32-1.961a1.245 1.245 0 0 1 1.52.878 1.242 1.242 0 0 1-.878 1.52l-3.798 1.018a61.013 61.013 0 0 0 11.821 2.401ZM40.11 120.664c.129-.099.276-.172.434-.214l15.986-4.284a1.245 1.245 0 0 1 1.52.878 1.242 1.242 0 0 1-.878 1.52l-15.986 4.283a1.24 1.24 0 0 1-1.396-1.819c.082-.141.19-.265.32-.364Zm1.665 8.816a1.24 1.24 0 0 0 .611 1.237c.285.164.624.209.942.124l15.986-4.284a1.24 1.24 0 0 0 .836-1.509 1.242 1.242 0 0 0-1.478-.889l-15.987 4.284a1.242 1.242 0 0 0-.91 1.037Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        fillRule="evenodd"
        d="m63.084 139.683 2.962-.794a3.31 3.31 0 0 0 2.34-4.054l-5.997-22.381a3.3 3.3 0 0 0-1.542-2.01 3.321 3.321 0 0 0-2.512-.33l-22.381 5.997h-.001a3.31 3.31 0 0 0-2.34 4.054l2.726 10.173a60.993 60.993 0 0 0 10.76 5.489l7.32-1.961a1.245 1.245 0 0 1 1.52.878 1.242 1.242 0 0 1-.878 1.52l-3.798 1.018a61.013 61.013 0 0 0 11.821 2.401ZM40.11 120.664c.129-.099.276-.172.434-.214l15.986-4.284a1.245 1.245 0 0 1 1.52.878 1.242 1.242 0 0 1-.878 1.52l-15.986 4.283a1.24 1.24 0 0 1-1.396-1.819c.082-.141.19-.265.32-.364Zm1.665 8.816a1.24 1.24 0 0 0 .611 1.237c.285.164.624.209.942.124l15.986-4.284a1.24 1.24 0 0 0 .836-1.509 1.242 1.242 0 0 0-1.478-.889l-15.987 4.284a1.242 1.242 0 0 0-.91 1.037Z"
        clipRule="evenodd"
      />
      <path
        fill="#D9D9D9"
        d="M41.807 129.963a1.24 1.24 0 0 1 .878-1.52l15.987-4.284a1.242 1.242 0 0 1 .642 2.398l-15.986 4.284a1.244 1.244 0 0 1-1.521-.878Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M41.807 129.963a1.24 1.24 0 0 1 .878-1.52l15.987-4.284a1.242 1.242 0 0 1 .642 2.398l-15.986 4.284a1.244 1.244 0 0 1-1.521-.878Z"
      />
      <path
        fill="#D9D9D9"
        d="M41.807 129.963a1.24 1.24 0 0 1 .878-1.52l15.987-4.284a1.242 1.242 0 0 1 .642 2.398l-15.986 4.284a1.244 1.244 0 0 1-1.521-.878ZM54.419 133.866l-7.32 1.961 4.164 1.455 3.798-1.018a1.241 1.241 0 1 0-.642-2.398Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="m54.419 133.866-7.32 1.961 4.164 1.455 3.798-1.018a1.241 1.241 0 1 0-.642-2.398Z"
      />
      <path
        fill="#D9D9D9"
        d="m54.419 133.866-7.32 1.961 4.164 1.455 3.798-1.018a1.241 1.241 0 1 0-.642-2.398Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.816 124.854c.279-.248.556-.497.83-.748a.5.5 0 1 0-.676-.737c-.54.495-1.089.981-1.646 1.457a.51.51 0 0 0-.186.343.49.49 0 0 0 .275.496.494.494 0 0 0 .39.024.51.51 0 0 0 .17-.103c.283-.241.564-.485.843-.732Zm3.274-4.556a.497.497 0 0 0-.105.555.505.505 0 0 0 .283.268.486.486 0 0 0 .389-.017.478.478 0 0 0 .159-.119 61.571 61.571 0 0 0 4.316-5.089.497.497 0 0 0-.096-.701.499.499 0 0 0-.701.096 60.455 60.455 0 0 1-4.245 5.007Zm-9.417 9.343a.49.49 0 0 0 .21-.32.512.512 0 0 0-.079-.375.504.504 0 0 0-.32-.209.502.502 0 0 0-.375.078 60.106 60.106 0 0 1-3.7 2.336.503.503 0 0 0-.181.684.502.502 0 0 0 .684.181 61.62 61.62 0 0 0 3.761-2.375Zm-5.706 3.46a.502.502 0 0 0-.09-.92.5.5 0 0 0-.381.038c-18.15 9.695-39.99 9.416-57.775-.37a.49.49 0 0 0-.38-.042.494.494 0 0 0-.358.424.5.5 0 0 0 .255.494c18.08 9.947 40.278 10.232 58.73.376Zm24.138-25.146a.509.509 0 0 0 .048.554.508.508 0 0 0 .529.168.507.507 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.498.498 0 0 0-.919.089.5.5 0 0 0 .036.381c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.503.503 0 0 0 .684.181.5.5 0 0 0 .181-.684 60.76 60.76 0 0 0-2.374-3.762.498.498 0 0 0-.904.19.501.501 0 0 0 .078.374 60.066 60.066 0 0 1 2.335 3.7v.001ZM32.777 127.88a.492.492 0 0 0 .7-.097.49.49 0 0 0 .098-.37.503.503 0 0 0-.194-.33 60.521 60.521 0 0 1-5.007-4.244.498.498 0 0 0-.686.04.5.5 0 0 0 0 .687 61.529 61.529 0 0 0 5.09 4.314Zm-8.212-7.484a.5.5 0 1 0 .737-.676 61.999 61.999 0 0 1-.7-.776C2.462 93.874 4.83 55.586 29.906 33.401c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.502.502 0 0 0 .044-.718 54.274 54.274 0 0 0-.655-.755l-.006-.008-.036-.04-.035-.04a61.688 61.688 0 0 0-3.805-3.926.431.431 0 0 0-.065-.073 61.243 61.243 0 0 0-5.09-4.314.48.48 0 0 0-.128-.071 61.168 61.168 0 0 0-7.186-4.653.499.499 0 0 0-.147-.12c-18.08-9.949-40.278-10.234-58.728-.377a.498.498 0 0 0-.22.237 57.12 57.12 0 0 0-1.407.785.498.498 0 0 0-.318.063 61.565 61.565 0 0 0-3.761 2.375.5.5 0 0 0-.196.262 62.219 62.219 0 0 0-4.8 3.673.498.498 0 0 0-.305.12c-.566.483-1.123.977-1.672 1.48a.5.5 0 0 0-.156.288 62.467 62.467 0 0 0-2.724 2.682.499.499 0 0 0-.29.151 61.682 61.682 0 0 0-4.316 5.089.498.498 0 0 0-.102.308 61.228 61.228 0 0 0-4.513 6.935.499.499 0 0 0-.234.215C6.04 67.072 5.733 89.27 15.574 107.715c.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.047.03.093.055.136a61.347 61.347 0 0 0 2.373 3.763.496.496 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.043.048c.221.25.443.497.67.742Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path fill="#fff" stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.99 21h78v76h-78V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.99 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM82.99 30.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 39.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 48.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 57.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 66.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 75.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM38.767 21H26.395a.905.905 0 0 0 0 1.81h12.372a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M83.085 21h-5.281a.905.905 0 0 0 0 1.81h5.281a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M74.221 21H68.94a.905.905 0 0 0 0 1.81h5.281a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.449 24.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 113.214c7.403 0 13.404-5.997 13.404-13.394s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.394 13.404 13.394Zm1.675-18.416a1.675 1.675 0 0 0-3.35 0v3.348h-3.351a1.675 1.675 0 1 0 0 3.348h3.35v3.349a1.674 1.674 0 0 0 1.676 1.676 1.677 1.677 0 0 0 1.676-1.676v-3.349h3.35a1.674 1.674 0 1 0 0-3.348h-3.35l-.001-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M119.5 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M119.5 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        stroke={primary}
        d="M119.5 22c0-9.389-7.611-17-17-17s-17 7.611-17 17 7.611 17 17 17 17-7.611 17-17Z"
      />
      <path
        fill={primary}
        d="M97 15.5a2 2 0 0 1 2-2h4.585a2 2 0 0 1 1.415.586l3.414 3.414a2 2 0 0 1 .586 1.414V27.5a2 2 0 0 1-2 2h-1.528a5.998 5.998 0 0 0-.231-8.241A6 6 0 0 0 97 21.028V15.5Z"
      />
      <path
        fill={primary}
        fillRule="evenodd"
        d="M101 21.5a4.001 4.001 0 0 0-3.446 6.032l-1.261 1.26a1 1 0 1 0 1.414 1.415l1.26-1.261a4 4 0 1 0 2.032-7.446H101Zm-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        stroke={primary}
        d="M137.5 69.5h-13A1.5 1.5 0 0 0 123 71v13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 139 84V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M128.708 75h4.583m-4.583 2.5h4.583m-4.583 2.5h2.75m2.75-7h-6.417c-.506 0-.916.448-.916 1v7c0 .552.41 1 .916 1h6.417c.506 0 .917-.448.917-1v-7c0-.552-.411-1-.917-1Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.427"
          y2="113.214"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default SemanticSearch;
